/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum ExecuteActionStatus {
  Success = 'Success',
  DryRun = 'DryRun',
  RequiredParametersNotProvided = 'RequiredParametersNotProvided',
  RedRobinConnectionNotFound = 'RedRobinConnectionNotFound',
  ResourceNotFound = 'ResourceNotFound',
  CreateDeeplinkFailed = 'CreateDeeplinkFailed',
  FailedToCreateMessagingCase = 'FailedToCreateMessagingCase',
  InvalidReceptionConfig = 'InvalidReceptionConfig',
  WebhookFailed = 'WebhookFailed'
}
